module.exports = __webpack_public_path__ + "static/media/yellow-paint.b4ffb94a.png";